import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from "@angular/router";

import { BehaviorSubject, Observable } from "rxjs";
import { environment } from "environments/environment";
import Swal from "sweetalert2";

@Injectable()
export class PaymentListService implements Resolve<any> {
  public rows: any;
  public onPaymentListChanged: BehaviorSubject<any>;

  /**
   * Constructor
   *
   * @param {HttpClient} _httpClient
   */
  constructor(private _httpClient: HttpClient) {
    // Set the defaults
    this.onPaymentListChanged = new BehaviorSubject({});
  }

  /**
   * Resolver
   *
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> | Promise<any> | any {
    return new Promise<void>((resolve, reject) => {
      Promise.all([this.getData()]).then(() => {
        resolve();
      }, reject);
    });
  }

  /**
   * Get rows
   */
  getDataTableRows(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this._httpClient.get("api/users-data").subscribe((response: any) => {
        this.rows = response;
        this.onPaymentListChanged.next(this.rows);
        resolve(this.rows);
      }, reject);
    });
  }

   /**
   * Get row test function
   */
  getDataTableRowsTest() {
    return this._httpClient.get<any>("api/payment-list");
  }

  /**
   * Get rows
   */
  getData(): Promise<any[]> {    
    return new Promise((resolve, reject) => {
      this._httpClient
        .get(`${environment.apiUrl}/instalment_payment`)
        .subscribe((response: any) => {
          this.rows = response;
          this.onPaymentListChanged.next(this.rows);
          resolve(this.rows);
        }, reject);
    });
  }

  /**
   * Send list
   *
   */
  sendList(location_id, file): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this._httpClient
        .post(`${environment.apiUrl}/referral/${location_id}/importcsv`, {
          csvfile: file,
        })
        .subscribe((response: any) => {
          Swal.fire({
            icon: "success",
            title: "Your list has been sent successfully!",
            html: `
                <div>
                  <p>
                    You sent ${
                      response.done.length + response.failed.length
                    } referral(s). 
                    <br>
                    ${response.done.length} were saved and ${
              response.failed.length
            } failed.
                  </p>
                  <br><br>
                </div>
                
                `,
            confirmButtonText: "Copy list",

            showClass: { popup: "animate__animated animate__flipInX" },
            showCancelButton: false,
            customClass: {
              confirmButton: "btn btn-primary",
              cancelButton: "btn btn-danger ml-1",
            },
          }).then((data) => {
            if (data.isConfirmed == true) {
              var copy = "Email saved: ";
              response["done"].forEach((element) => {
                copy += element.email;
                copy += " ";
              });
              copy += " Email failed: ";

              response["failed"].forEach((element) => {
                copy += element.email;
                copy += " ";
              });
              navigator.clipboard.writeText(copy);
            } else {
              var reason = String(data.dismiss);
              switch (reason) {
                case "cancel":
                  //this.sendDeleteLink(inviteLink.token)
                  break;

                default:
                  break;
              }
            }
          });

          resolve(this.rows);
        }, reject);
    });
  }
  getPaymentTypeName(payment: string) {
    let paymentTypeStr: string = '';
    switch(payment) {
      case 'instant_payment':
        paymentTypeStr = 'Instant Payment'
      break;
      case 'instalment_payment':
        paymentTypeStr = 'Instalment Payment'
      break;
    }
    return paymentTypeStr;
  }
}
